import React, { Component } from 'react'
import { connect } from 'react-redux'

import { AppState } from '../../store'
import { AppModeEnum } from '../../shared/models'

import TaggingReviewDistributor from './distributor/TaggingReviewDistributor'
import TaggingReviewServiceProvider from './service-provider/TaggingReviewServiceProvider'

interface State {}

interface DispatchProps {}

type Props = AppState & DispatchProps

const mapStateToProps = state => ({ ...state })
const mapDispatchToProps = () => ({})

class TaggingReview extends Component<Props, State> {
  render(): JSX.Element {
    const {
      appMode: { activeMode },
    } = this.props

    if (activeMode === AppModeEnum.Distributors) {
      return <TaggingReviewDistributor />
    } else {
      return <TaggingReviewServiceProvider />
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaggingReview)
